export const CREATE_MACHINE  = 'CREATE_MACHINE';
export const GET_MACHINE  = 'GET_MACHINE';
export const MACHINE_REQUEST  = 'MACHINE_REQUEST';
export const DELETE_MACHINE  = 'DELETE_MACHINE';
export const UPDATE_MACHINE  = 'UPDATE_MACHINE';
export const MACHINE_REQUEST_FAILURE  = 'MACHINE_REQUEST_FAILURE';